export default "__VITE_ASSET__lknz4IPQ__"